/* The list card's toolbar — KANON `Cwiczenia` 17.09.2026, variant e.
 *
 * The specimen transcribes the Programy toolbar verbatim and then adds two things: a hairline
 * separator, and a second 27px square for the preview panel. So the layout below is the plan
 * library's own, and the SQUARE is `shared/ui/filterSquare.module.css` — three copies of one
 * declaration block is what moving it there prevented. */

.toolbar {
  display: flex;
  flex: none;
  gap: var(--space-6-5px);
  align-items: center;
  padding: var(--space-10-5px) var(--space-13px) var(--space-9px);
}

/* An 18px hairline between the two squares: the filter narrows the LIST, the toggle changes the
 * LAYOUT, and the specimen separates them rather than letting a trainer read them as a pair. */
.separator {
  flex: none;
  width: 1px;
  height: 18px;
  margin: var(--space-0) var(--space-2px);
  background: var(--border);
}

/* The panel toggle's own pressed state, which `filterSquare` deliberately does not own: the filter
 * trigger has no such state (a popup is open or it is not), and this one is `aria-pressed`. The
 * inset fill and the stronger edge are the specimen's `.le-toggle[aria-pressed='true']`. */
.toggleOn {
  color: var(--text);
  background: var(--bg-inset);
  border-color: var(--border-2);
}

.toggleIcon {
  display: block;
  flex: none;
  width: 14px;
  height: 14px;
}

/* The search field's words at 13px here, where the plan library's compact cut prints 11 (polish of
 * 4 November 2026). Under `.toolbar` so it outranks `SearchField`'s own `.compact .input`. */
.toolbar .search input {
  font-size: var(--type-control);
}

/* Board D's `.tog`, worn in this toolbar's own control skin (`filterSquare`'s height, fill, edge
 * and radius) so it stands level with the two squares: „Do uzupełnienia" with its count. Pressed, it
 * takes an ink outline and ink words rather than a solid ink pill (polish of 4 November 2026). */
.review {
  display: inline-flex;
  flex: none;
  gap: var(--space-6px);
  align-items: center;
  height: var(--h-pl-control);
  padding: var(--space-0) var(--space-10px);
  font-family: var(--font-body);
  font-size: var(--fs-note);
  font-weight: var(--fw-extrabold);
  color: var(--text-2);
  cursor: pointer;
  background: var(--bg-chip);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-mark);
  transition-duration: var(--dur-base);
  transition-property: color, background-color, border-color;
  transition-timing-function: var(--ease);
}

.review:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

.review[aria-disabled='true'] {
  cursor: default;
  opacity: 0.4;
}

.reviewOn {
  color: var(--text);
  background: transparent;
  border-color: var(--text);
}

/* The figure reserves three digits rather than growing when the read lands, as the scope switch's
 * count does (`ExerciseScopeSwitch.module.css`): the word beside it never moves. */
.reviewCount {
  display: inline-grid;
  place-items: center start;
  font-weight: var(--fw-bold);
  font-variant-numeric: tabular-nums;
  opacity: 0.7;
}

.reviewCount::before {
  grid-area: 1 / 1;
  content: '000';
  visibility: hidden;
}

.reviewFigure {
  grid-area: 1 / 1;
  font-weight: inherit;
}
